"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var _default = function _default(config) {
  return {
    serviceName: 'retrieveNotificationInitialCount',
    authenticate: true,
    config: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      url: (0, _get.default)(config, 'endpoints.prompt.notifications.count')
    }
  };
};
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/service-configs/notifications/retrieve-notification-initial-count.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjb25maWciLCJzZXJ2aWNlTmFtZSIsImF1dGhlbnRpY2F0ZSIsIm1ldGhvZCIsImhlYWRlcnMiLCJBY2NlcHQiLCJ1cmwiLCJnZXQiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc2VydmljZXMvc2VydmljZS1jb25maWdzL25vdGlmaWNhdGlvbnMvcmV0cmlldmUtbm90aWZpY2F0aW9uLWluaXRpYWwtY291bnQuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGdldCBmcm9tICdsb2Rhc2gvZ2V0JztcblxuZXhwb3J0IGRlZmF1bHQgKGNvbmZpZykgPT4gKHtcblx0c2VydmljZU5hbWU6ICdyZXRyaWV2ZU5vdGlmaWNhdGlvbkluaXRpYWxDb3VudCcsXG5cdGF1dGhlbnRpY2F0ZTogdHJ1ZSxcblx0Y29uZmlnOiB7XG5cdFx0bWV0aG9kOiAnUE9TVCcsXG5cdFx0aGVhZGVyczoge1xuXHRcdFx0QWNjZXB0OiAnYXBwbGljYXRpb24vanNvbicsXG5cdFx0XHQnQ29udGVudC1UeXBlJzogJ2FwcGxpY2F0aW9uL2pzb24nLFxuXHRcdH0sXG5cdFx0dXJsOiBnZXQoY29uZmlnLCAnZW5kcG9pbnRzLnByb21wdC5ub3RpZmljYXRpb25zLmNvdW50JyksXG5cdH0sXG59KTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBO0FBQTZCO0VBQUE7RUFBQTtBQUFBO0FBQUE7RUFBQTtBQUFBO0FBQUEsZUFFZCxrQkFBQ0EsTUFBTTtFQUFBLE9BQU07SUFDM0JDLFdBQVcsRUFBRSxrQ0FBa0M7SUFDL0NDLFlBQVksRUFBRSxJQUFJO0lBQ2xCRixNQUFNLEVBQUU7TUFDUEcsTUFBTSxFQUFFLE1BQU07TUFDZEMsT0FBTyxFQUFFO1FBQ1JDLE1BQU0sRUFBRSxrQkFBa0I7UUFDMUIsY0FBYyxFQUFFO01BQ2pCLENBQUM7TUFDREMsR0FBRyxFQUFFLElBQUFDLFlBQUcsRUFBQ1AsTUFBTSxFQUFFLHNDQUFzQztJQUN4RDtFQUNELENBQUM7QUFBQSxDQUFDO0FBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0lBQUE7RUFBQTtFQUFBO0FBQUE7QUFBQTtBQUFBO0VBQUE7RUFBQTtBQUFBIn0=